
import { useStore } from '@/store'
import { defineComponent, ref, onMounted } from 'vue'
import { computed } from 'vue'
import edgeSettings from '@/settings/edge-settings.json'
import FormOption from '@/components/Form/FormOption.vue'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import { ColorpickerActionTypes } from '@/store/modules/colorpicker/action-types'
import Analytics from '@/singletons/analytics'
import FormScrollableTab from '@/components/Abstract/FormScrollableTab.vue'
import FormColorPicker from '@/components/Form/FormColorPicker.vue'
import FormColorSlider from '@/components/Form/FormColorSlider.vue'
import StageDeterminerService from '@/services/page/stage-determiner.service'

export default defineComponent({
  name: 'FormEdge',
  components: {
    FormScrollableTab,
    FormOption,
    FormColorPicker,
    FormColorSlider
  },
  props: {
    index: Number
  },
  setup() {
    let stageDeterminer = new StageDeterminerService()
    const store = useStore()
    const configName = ref('configEdgeId')
    const colorpicker = ref("#2e2e2e")
    const glosiness = ref("50")
    const metalness = ref("10")
    const showColorPicker = ref(false)
    const config = computed(() => store.getters[configName.value])
    const options = computed(() => edgeSettings.edgeColors)

    onMounted(() => {
      if (stageDeterminer.isColorpickerVisible()) {
        showColorPicker.value = true
      }
    })

    const onClick = (option: any) => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_EDGE, option.id)
      Analytics.instance.sendEdgeEvent(option.id)

      colorpicker.value = option.value || "#2e2e2e";
      glosiness.value = option.glosiness ? option.glosiness.toString() : "50";
      metalness.value = option.metalness ? option.metalness.toString() : "10";
    }

    const onColorPickerUpdate = (val) => {
      store.dispatch(ColorpickerActionTypes.SET_COLORPICKER_EDGE, val)
    }

    const onColorGlosinessUpdate = (val) => {
      store.dispatch(ColorpickerActionTypes.SET_COLORPICKER_EDGE_GLOSINESS, val)
      glosiness.value = val ? val : "50";
    }

    const onColorMetalnessUpdate = (val) => {
      store.dispatch(ColorpickerActionTypes.SET_COLORPICKER_EDGE_METALNESS, val)
      metalness.value = val ? val : "10";
    }

    return {
      config,
      configName,
      edgeSettings,
      colorpicker,
      glosiness,
      metalness,
      onClick,
      options,
      showColorPicker,
      onColorPickerUpdate,
      onColorGlosinessUpdate,
      onColorMetalnessUpdate
    }
  }
})
